import React, {useMemo, useState} from "react";
import PropTypes from "prop-types";
import {getIntlLocale} from "../../lib/getIntlLocale";
import {BackupDeleteDialog} from "./BackupDeleteDialog";

export function Backup(props) {
  const intlLocale = getIntlLocale();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const date = useMemo(() => {
    const createdAt = new Date(props.backup.createdAt);
    const options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    };
    return createdAt.toLocaleDateString(intlLocale, options);
  }, [intlLocale, props.backup.createdAt]);


  function openDeleteDialog() {
    setIsDeleteDialogOpen(true);
  }

  function closeDeleteDialog() {
    setIsDeleteDialogOpen(false);
  }

  return (
    <React.Fragment>
      <div className="account-backup">
        <div className="account-backup__glyph-circle">
          <span className="glyph-system-backups"/>
        </div>
        <div className="account-backup__info">
          <div className="account-backup__version">{props.backup.version}</div>
          <div className="account-backup__date">{date}</div>
        </div>
        <button className="account-backup__delete-button glyph-core-trash-fill" onClick={openDeleteDialog}/>
      </div>
      <BackupDeleteDialog
        isOpen={isDeleteDialogOpen}
        onClose={closeDeleteDialog}
        backup={props.backup}
        onDelete={props.onDelete}
      />
    </React.Fragment>
  );
}

Backup.propTypes = {
  backup: PropTypes.shape({
    backupId: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
};
